"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { trackPageView } from "@/lib/analytics";

interface SegmentProviderProps {
  children: React.ReactNode;
}

const SegmentProvider = ({ children }: SegmentProviderProps) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  // Track page views whenever the URL changes
  useEffect(() => {
    // Track page view on initial load and on URL changes
    trackPageView();
  }, [pathname, searchParams]);

  return <>{children}</>;
};

export default SegmentProvider;
